<template>
  <vl-grid v-vl-spacer:top.medium>
    <vl-column>
      <div class="pbs-form-group">
        <vl-grid mod-stacked>
          <vl-column width="3" width-s="6" width-xs="12">
            <vl-form-message-label for="id">{{ $t('entitymodel.list.filter.id.label') }}</vl-form-message-label>
            <vl-input-field
              id="id"
              v-model="filter.id"
              name="id"
              type="number"
              :placeholder="$t('entitymodel.list.filter.id.label')"
              mod-block
              @keyup.enter="doSearch"
            />
          </vl-column>
          <vl-column width="3" width-s="6" width-xs="12">
            <vl-form-message-label for="code">{{ $t('entitymodel.list.filter.code.label') }}</vl-form-message-label>
            <vl-input-field
              id="code"
              v-model="filter.code"
              name="code"
              type="search"
              :placeholder="$t('entitymodel.list.filter.code.label')"
              mod-block
              @keyup.enter="doSearch"
            />
          </vl-column>
          <vl-column width="3" width-s="6" width-xs="12">
            <vl-form-message-label for="label">{{ $t('entitymodel.list.filter.label.label') }}</vl-form-message-label>
            <vl-input-field
              id="label"
              v-model="filter.label"
              name="label"
              type="search"
              :placeholder="$t('entitymodel.list.filter.label.label')"
              mod-block
              @keyup.enter="doSearch"
            />
          </vl-column>
          <vl-column width="3" width-s="6" width-xs="12">
            <vl-form-message-label for="description">{{
              $t('entitymodel.list.filter.description.label')
            }}</vl-form-message-label>
            <vl-input-field
              id="description"
              v-model="filter.description"
              name="description"
              type="search"
              :placeholder="$t('entitymodel.list.filter.description.label')"
              mod-block
              @keyup.enter="doSearch"
            />
          </vl-column>
          <vl-column width="3" width-s="6" width-xs="12">
            <vl-form-message-label for="contextId">{{
              $t('entitymodel.list.filter.contextId.label')
            }}</vl-form-message-label>
            <PbsSelect
              id="contextId"
              v-model="filter.contextType"
              value-property="name"
              :placeholder="$t('vl-select.placeholder')"
              :options="contextTypes"
              :custom-label="(e) => e.name"
            />
          </vl-column>
          <vl-column width="3" width-s="6" width-xs="12">
            <vl-form-message-label for="entityId">{{
              $t('entitymodel.list.filter.entityId.label')
            }}</vl-form-message-label>
            <PbsSelect
              id="entityId"
              v-model="filter.entityType"
              value-property="name"
              :placeholder="$t('vl-select.placeholder')"
              :options="entityTypes"
              :custom-label="(e) => e.name"
            />
          </vl-column>
          <vl-column width="3" width-s="6" width-xs="12">
            <vl-form-message-label>{{ $t('entitymodel.list.filter.hasHistory.label') }}</vl-form-message-label>
            <vl-radio
              id="hasHistory_1"
              v-model="filter.hasHistory"
              name="hasHistory_1"
              :value="true"
              type="radio"
              mod-block
              @click="radioClicked(true)"
              >{{ $t('general.yes') }}</vl-radio
            >
            <vl-radio
              id="hasHistory_0"
              v-model="filter.hasHistory"
              :value="false"
              name="hasHistory_0"
              type="radio"
              @click="radioClicked(false)"
              >{{ $t('general.no') }}</vl-radio
            >
          </vl-column>
          <vl-column width="3" width-s="6" width-xs="12">
            <vl-form-message-label for="statusId">{{
              $t('entitymodel.list.filter.status.label')
            }}</vl-form-message-label>
            <PbsSelect
              id="statusId"
              v-model="filter.statusType"
              value-property="name"
              :placeholder="$t('vl-select.placeholder')"
              :options="statusTypes"
              :custom-label="(e) => e.name"
            />
          </vl-column>
          <vl-column width="6" width-s="6" width-xs="12">
            <vl-form-message-label for="definition" class="vl-search-filter__field__label">{{
              $t('entitymodel.list.filter.deliveryProcessDefinition.label')
            }}</vl-form-message-label>
            <PbsSelect
              id="deliveryProcessDefinition"
              v-model="filter.deliveryProcessDefinition"
              :options="deliveryProcessDefinitionOptions"
              :placeholder="$t('vl-select.placeholder')"
              :custom-label="getDeliveryProcessDefinitionLabel"
            />
          </vl-column>
          <vl-column width="6" width-s="6" width-xs="12">
            <vl-form-message-label for="definition" class="vl-search-filter__field__label">{{
              $t('entitymodel.list.filter.productProcessDefinition.label')
            }}</vl-form-message-label>
            <PbsSelect
              id="productProcessDefinition"
              v-model="filter.productProcessDefinition"
              :options="productProcessDefinitionOptions"
              :placeholder="$t('vl-select.placeholder')"
              :custom-label="getProductProcessDefinitionLabel"
            />
          </vl-column>
          <vl-column v-vl-spacer:top.small width="9" width-s="9" width-xs="12">
            <vl-action-group>
              <vl-button @click="doSearch">{{ $t('entitymodel.list.filter.search') }}</vl-button>
              <vl-button mod-secondary @click="clear">{{ $t('entitymodel.list.filter.clear') }}</vl-button>
            </vl-action-group>
          </vl-column>
          <vl-column v-vl-spacer:top.small width="3" width-s="3" width-xs="12">
            <vl-action-group mod-align-right>
              <vl-button mod-primary @click="openImportModal">{{ $t('entitymodel.list.filter.import') }}</vl-button>
              <vl-button mod-secondary @click="create">{{ $t('entitymodel.list.filter.create') }}</vl-button>
            </vl-action-group>
          </vl-column>
        </vl-grid>
      </div>
    </vl-column>
  </vl-grid>
  <vl-grid v-vl-spacer:top.medium>
    <vl-data-table-extended
      v-if="items"
      :data="items"
      :columns="columnMap"
      :fetching="loading"
      :meta="metaData"
      mod-clickable-rows
      mod-zebra
      @column-clicked="columnClicked"
      @pager-clicked="pagerClicked"
    >
      <template v-slot:noresults>
        <template v-if="loading">
          <vl-region>
            <div v-vl-align:center>
              <vl-loader :message="$t('general.pageLoading')" />
            </div>
          </vl-region>
        </template>
        <template v-else-if="isMounted">
          <div v-vl-align:left>
            <div class="vl-u-spacer--large">
              <vl-title tag-name="h2">{{ $t('entitymodel.list.table.noResults.title') }}</vl-title>
              <p>{{ $t('entitymodel.list.table.noResults.subtitle') }}</p>
            </div>
          </div>
        </template>
      </template>
    </vl-data-table-extended>
  </vl-grid>
</template>
<script lang="ts" setup>
import { Ref, computed, ref, h, reactive } from 'vue';
import { ModelListFilter, useEntityModelListStore } from '../../store/entity-model/entity-model-list.store';
import { onMounted, onUnmounted } from 'vue';
import { ColumnDefExtended } from '@/components/vl-data-table-extended/types';
import { RowData } from '@tanstack/vue-table';
import {
  DeliveryProcessDefinitionBasicDto,
  EnumerationDto,
  ProductProcessDefinitionBasicDto,
  SearchEntityModelDto
} from '@/api/backoffice/clients';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useAlertStore, IAlert } from '@/modules/core/store/alert.store';
import {
  ENUM_ContextTypes,
  ENUM_EntityTypes,
  ENUM_StatusTypes,
  EntityModelActionButtonType
} from '@/modules/configuration/common';
import EntityModelActionButton from './subcomponents/entity-model-action-button/EntityModelActionButton.vue';
import PbsSelect from '@/components/forms/PbsSelect.vue';
import EntityModelImportForm from './subcomponents/entity-model-import-form/EntityModelImportForm.vue';
import { useModalStore } from '@/modules/core/store/modal.store';
import { useDeliveryProcessDefinitionListStore } from '../../store/delivery-process-definition/delivery-process-definition-list.store';
import { useProductProcessDefinitionListStore } from '../../store/product-process-definition/product-process-definition-list.store';
import { getDeliveryProcessDefinitionLabel } from '@/modules/configuration/common/delivery-process-definition.common';
import { getProductProcessDefinitionLabel } from '@/modules/configuration/common/product-process-definition.common';

const store = useEntityModelListStore();
const deliveryProcessDefinitionStore = useDeliveryProcessDefinitionListStore();
const productProcessDefinitionStore = useProductProcessDefinitionListStore();

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const deliveryProcessDefinitionOptions: Ref<DeliveryProcessDefinitionBasicDto[]> = ref([]);
const productProcessDefinitionOptions: Ref<ProductProcessDefinitionBasicDto[]> = ref([]);

const isMounted = ref(false);

const filter = computed((): ModelListFilter => {
  return store.filter ?? {};
});

const loading = computed((): boolean => {
  return store.loading;
});

const items = computed((): SearchEntityModelDto & { routerLink?: string }[] => {
  return store.items?.map((i) => {
    return {
      ...i,
      routerLink: `/configuration/entitymodel/${i.id}`
    };
  });
});

const metaData = computed(() => {
  return store.metaData;
});

const columnMap = computed((): ColumnDefExtended<RowData>[] => {
  return [
    {
      accessorKey: 'id',
      header: t('entitymodel.list.table.header.id'),
      enableSorting: true,
      size: 5,
      link: true
    },
    {
      accessorKey: 'code',
      header: t('entitymodel.list.table.header.code'),
      enableSorting: true,
      size: 20,
      link: true
    },
    {
      accessorKey: 'label',
      header: t('entitymodel.list.table.header.label'),
      enableSorting: true,
      sortDescFirst: false,
      size: 30,
      link: true
    },
    {
      accessorKey: 'contextTypeName',
      header: t('entitymodel.list.table.header.contextType'),
      enableSorting: true,
      size: 20,
      link: true
    },
    {
      accessorKey: 'entityTypeName',
      header: t('entitymodel.list.table.header.entityType'),
      enableSorting: true,
      size: 20,
      link: true
    },
    {
      accessorKey: 'hasHistory',
      header: t('entitymodel.list.table.header.hasHistory'),
      enableSorting: true,
      size: 5,
      link: true,
      cell: (props) => {
        return props?.getValue() ? t('general.yes') : t('general.no');
      }
    },
    {
      accessorKey: 'statusId',
      header: t('entitymodel.list.table.header.status'),
      enableSorting: true,
      size: 20,
      link: true,
      cell: (props) => {
        const statusType = Object.values(ENUM_StatusTypes).find((s) => s.id === props?.getValue());
        return statusType?.name || '-';
      }
    },
    {
      accessorKey: '',
      header: t('entitymodel.list.table.header.actions'),
      size: 10,
      cell: (props) => {
        const detail = props.row.original;
        const actions = [
          EntityModelActionButtonType.ChangeStatus,
          EntityModelActionButtonType.Duplicate,
          EntityModelActionButtonType.CascadeDelete
        ];
        return h(EntityModelActionButton, { detail, actions, modVertical: true });
      }
    }
  ];
});

const contextTypes = computed((): EnumerationDto[] => {
  return Object.values(ENUM_ContextTypes);
});

const entityTypes = computed((): EnumerationDto[] => {
  return Object.values(ENUM_EntityTypes);
});

const statusTypes = computed((): EnumerationDto[] => {
  return Object.values(ENUM_StatusTypes);
});

const alert = computed((): IAlert => {
  return useAlertStore().alert;
});

onMounted(() => {
  setTimeout(async () => {
    deliveryProcessDefinitionOptions.value = await deliveryProcessDefinitionStore.getAll();
    productProcessDefinitionOptions.value = await productProcessDefinitionStore.getAll();
    store.init(createFilterFromRoute());
    await search();
    isMounted.value = true;
  }, 0);
});

// All configuration tabs share one route, so a search that is still running when the user
// switches tab must not write its filter back into the query string afterwards.
let isActive = true;

onUnmounted(() => {
  isActive = false;
  store.clearFilter();
});

const clear = async () => {
  store.clearFilter();
  await search();
};

const doSearch = async () => {
  await search({ resetPager: true });
};

const search = async ({ resetPager }: { resetPager: boolean } = { resetPager: false }) => {
  if (resetPager) {
    store.resetPager();
  }

  if (!resetPager) {
  }

  await store.getModels();
  if (isActive && !alert.value) {
    updateRoute();
  }
};

const create = () => {
  router.push({ name: 'entitymodel.create' });
};

const openImportModal = () => {
  const modalStore = useModalStore();

  const modalContent = {
    title: t('entitymodel.actions.import.description'),
    component: EntityModelImportForm
  };

  modalStore.showModal(modalContent);
};

const radioClicked = (checked) => {
  if (filter.value.hasHistory === checked) {
    filter.value.hasHistory = null;
  } else filter.value.hasHistory = checked;
};

const createFilterFromRoute = (): ModelListFilter => {
  const filter: ModelListFilter = {};

  Object.keys(route.query).forEach((k) => {
    if (k === 'deliveryProcessDefinition') {
      filter[k] = deliveryProcessDefinitionOptions.value.find((x) => x.id === parseInt(route.query[k] as string));
    } else if (k === 'productProcessDefinition') {
      filter[k] = productProcessDefinitionOptions.value.find((x) => x.id === parseInt(route.query[k] as string));
    } else {
      filter[k] = route.query[k] as string | number | boolean;
    }
  });

  return filter;
};

const updateRoute = () => {
  const query = {};
  Object.keys(store.filter).forEach((k) => {
    if (k === 'deliveryProcessDefinition') {
      query[k] = store.filter[k]?.id ? store.filter[k].id : '';
    } else if (k === 'productProcessDefinition') {
      query[k] = store.filter[k]?.id ? store.filter[k].id : '';
    } else {
      query[k] = store.filter[k];
    }
  });

  router.push({
    ...route,
    path: route.path,
    query
  });
};

const pagerClicked = (pageNumber: number) => {
  store.updatePage(pageNumber);
  search();
};

const columnClicked = (evt: { key: string; direction: string }) => {
  store.updateSorting(evt.key, evt.direction);
  search({ resetPager: true });
};
</script>
<style lang="scss" scoped>
@import '@govflanders/vl-ui-design-system-style/scss/core/setting/_colorsRaw.scss';
@import '@govflanders/vl-ui-design-system-style/scss/core/setting/_colors.scss';

.pbs-form-group {
  background: $vl-alt-bg;
  padding: 3rem;
}
.vl-grid {
  flex-grow: 1;
}
</style>
